import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authAPI } from '../services/api';
import { mensajeDeError } from '../utils/apiError';

export const useAuthStore = create(
    persist(
        (set, get) => ({
            user: null,
            token: null,
            subscription: null,
            isAuthenticated: false,
            isLoading: true,

            setUser: (user) => set({ user, isAuthenticated: !!user }),

            setToken: (token) => set({ token }),

            login: async (email, password) => {
                try {
                    const response = await authAPI.login({ email, password });
                    const { user, token } = response.data.data;
                    set({ user, token, isAuthenticated: true });
                    return { success: true };
                } catch (error) {
                    return {
                        success: false,
                        error: mensajeDeError(error)
                    };
                }
            },

            register: async (email, password, fullName) => {
                try {
                    const response = await authAPI.register({ email, password, fullName });
                    const { user, token } = response.data.data;
                    set({ user, token, isAuthenticated: true });
                    return { success: true };
                } catch (error) {
                    return {
                        success: false,
                        error: mensajeDeError(error)
                    };
                }
            },

            googleLogin: async (credential) => {
                try {
                    const response = await authAPI.googleLogin(credential);
                    const { user, token } = response.data.data;
                    set({ user, token, isAuthenticated: true });
                    return { success: true };
                } catch (error) {
                    return {
                        success: false,
                        error: mensajeDeError(error)
                    };
                }
            },

            logout: async () => {
                try {
                    await authAPI.logout();
                } catch (error) {
                    console.error('Logout error:', error);
                }
                set({ user: null, token: null, subscription: null, isAuthenticated: false });
            },

            checkAuth: async () => {
                const token = get().token;
                if (!token) {
                    set({ isLoading: false });
                    return;
                }

                try {
                    const response = await authAPI.getMe();
                    const { user, subscription } = response.data.data;
                    set({ user, subscription, isAuthenticated: true, isLoading: false });
                } catch (error) {
                    set({ user: null, token: null, isAuthenticated: false, isLoading: false });
                }
            },

            updateProfile: async (data) => {
                try {
                    const response = await authAPI.updateProfile(data);
                    set({ user: response.data.data.user });
                    return { success: true };
                } catch (error) {
                    return {
                        success: false,
                        error: mensajeDeError(error)
                    };
                }
            },

            forgotPassword: async (email, lang = 'es') => {
                try {
                    await authAPI.forgotPassword(email, lang);
                    return { success: true };
                } catch (error) {
                    return {
                        success: false,
                        error: mensajeDeError(error)
                    };
                }
            },

            resetPassword: async (token, password) => {
                try {
                    await authAPI.resetPassword({ token, password });
                    return { success: true };
                } catch (error) {
                    return {
                        success: false,
                        error: mensajeDeError(error)
                    };
                }
            }
        }),
        {
            name: 'auth-storage',
            partialize: (state) => ({ token: state.token }),
        }
    )
);
